import React from "react";

import DataTableColumnHeader from "../../../dataTable/DataTableColumnHeader";

import type { RowData } from "@tanstack/react-table";

import type { NumericKey } from "./figureColumn.types";
import type {
  ColumnLayout,
  DataTableColumnDef,
} from "../../../dataTable/dataTable.types";

export function figureColumn<TRow extends RowData>(
  id: NumericKey<TRow>,
  title: string,
  layout: ColumnLayout,
): DataTableColumnDef<TRow> {
  return {
    id,
    accessorFn: (row) => row[id],
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title={title} />
    ),
    meta: { ...layout, label: title, align: "center" },
    cell: ({ getValue }) => getValue<number>(),
  };
}
